import React, { useState, useEffect } from 'react';
import clsx from "clsx";
import PropTypes from 'prop-types';
import {
  makeStyles,
} from '@material-ui/core';
import { Card,
  CardContent,
  Grid,
  Typography,
 } from '@mui/material';
import {
  MAX_LENGTH
} from "common/constants";
import CountUp from 'react-countup';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import firebase from '../../Firebase';
import { getDatabase, ref, onValue, get, child } from 'firebase/database';
import numeral from 'numeral';

import i18n from 'i18n/i18n';  // i18n 객체 직접 import
import 'intl-pluralrules';




const AllCHGRStatus = props => {
  const { className, ...rest } = props;
  const classes = useStyles();


  const [cntOnCharge, setCntOnCharge] = useState();
  const [cntOnConn, setCntOnConn] = useState();
  const [cntOnDisconn, setCntOnDisconn] = useState();

  const database = getDatabase();
  const dbRef = ref(database);


  const makeSampleData = () => {

    onValue(child(dbRef, 'simu/summary/chgrs'), (snapshot) => {
      setCntOnCharge(snapshot.val().cnt_on_charge);
      setCntOnConn(snapshot.val().cnt_on_conn);
      setCntOnDisconn(numeral(snapshot.val().cnt_on_disconn).format('0,0.0'));
    });
  }

  useEffect(() => {
    makeSampleData();
  }, []);


  const eachCHGRStatus = (label, cur_val, diff_value) => {

    return (
      <Card raised={false} variant="outlined">
        <CardContent sx={{ p:1, '&:last-child': { pb: 1 }}}>
          <Grid container direction="row">

            <Grid container direction="column" alignItems="center" justifyContent="center" spacing={0}>
              <Grid item>
                <Typography className={classes.title} color="text.secondary" gutterBottom variant="body1">
                  {label}
                </Typography>
              </Grid>
            </Grid>


            <Grid container direction="row" alignItems="baseline" justifyContent="center" spacing={0}>

            <Typography variant="h6" >
              <CountUp end={cur_val} duration={0.5} separator="," decimals={0} />
            </Typography>

            <Typography variant="body2" paddingLeft="2px" >{i18n.t("ea")}</Typography>

            {/* <div className={classes.difference}
              style={{
                justifyContent: 'flex-end',
                verticalAlign: 'top', paddingTop: "0px"
                , paddingLeft: "4px"
              }}>
              <Typography className={classes.differenceValue} variant="body2">
                 {  diff_value == 0 ? (<span className={classes.grey}><strong>-</strong></span>) :
                    (diff_value > 0 ? (<span className={classes.green}><strong>▲</strong>{diff_value}</span>)
                      : (<span className={classes.red}><strong>▼</strong>{diff_value}</span>))}
              </Typography>
            </div> */}

            </Grid>
          </Grid>
        </CardContent>
      </Card>
    )
  }



  return (
    <div>
      <Grid container
        lg={12} md={12} xs={12}
        spacing={1}
        direction="row"
        alignItems="center"
        justifyContent="space-around"
      >

        <Grid item lg={2} md={2} xs={4}>
          <div style={{ textAlign: "center" }}>{i18n.t('chgr_aggr')}</div>
        </Grid>

        <Grid item lg={2} md={2} xs={4}>
          {eachCHGRStatus(i18n.t("charging"), cntOnCharge, 0)}
        </Grid>

        <Grid item lg={2} md={2} xs={4}>
          {eachCHGRStatus(i18n.t("idle"), cntOnConn, 0)}
        </Grid>

        <Grid item lg={2} md={2} xs={4}>
          {eachCHGRStatus(i18n.t("off-line"), cntOnDisconn, 0)}
        </Grid>

        <Grid item lg={2} md={2} xs={4}>
          {eachCHGRStatus(i18n.t("error"), 0, 0)}
        </Grid>

        <Grid item lg={2} md={2} xs={4}>
          {/* {eachCHGRStatus('Others', 0, 0)} */}
        </Grid>

      </Grid>
    </div>
  )
}


export default AllCHGRStatus;




const useStyles = makeStyles((theme) => ({

  root: {
  },

  chartContainer: {
    // //360px 이상
    // ['@media (min-height:360px)']: {// eslint-disable-line no-useless-computed-key
    //   height: 160,
    // },
    // //360px 이하
    // ['@media (max-height:360px)']: {// eslint-disable-line no-useless-computed-key
    //   height: 120,
    // },
    position: 'relative'
  },



  // title: {
  //   fontWeight: 500,
  //   marginBottom: theme.spacing(3),
  // },
  differenceValue: {
    // marginRight: theme.spacing(1),
  },
  difference: {
    // marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
  },
  // label: {
  //   marginLeft: theme.spacing(1),
  // },
  // labelbox: {
  //   margin: theme.spacing(2),
  // },
  // current: {
  //   marginTop: theme.spacing(0.5),
  //   marginRight: theme.spacing(0.5),
  //   // color: theme.palette.secondary.contrastText,
  //   // backgroundColor: theme.palette.secondary.main,
  // },

  grey: {
    // color: theme.palette.grey.light,
    color: 'lightgrey',
    fontWeight: 600,
  },

  green: {
    color: theme.palette.success.light,
    fontWeight: 600,
  },

  red: {
    color: theme.palette.error.light,
    // color: colors.red[400],
    fontWeight: 600,
  }
}));
